import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {FlexGrowItemBox} from '../../themes/architecture/css-helpers/flex';
import {observer} from 'mobx-react';
import classNames from "classnames";
import {ListTitleBox} from './boxes/list-title/list-title.box';

export interface GameListTitleComponentProps {
  className?: string;
  title: React.ReactElement;
}

@observer
export class GameListTitleComponent extends OrbitComponent<GameListTitleComponentProps> {

    render() {

        const cssClasses = classNames('cy-games-list-title', this.props.className);

        return (
            <ListTitleBox className={cssClasses}>
                {this.props.title}
                {this.services.mediaQuery.mAndAbove ? <FlexGrowItemBox /> : null}
                {this.props.children}
            </ListTitleBox>
        );
    }
}
